import { FileTools } from './file.tools';

export class ExportTools {

  static exportJSON(filename: string, json: string) {
    const createEl = document.createElement('a');
    createEl.href = 'data:application/json;charset=utf-8,' + encodeURIComponent(json);
    createEl.download = filename.replace(/ /g,"_") + '.json';
    createEl.click();
    createEl.remove();
  }

  static exportDXF(filename: string, text: any) {
    const createEl = document.createElement('a');
    createEl.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
    createEl.download = filename.replace(/ /g,"_") + '.dxf';
    createEl.click();
    createEl.remove();
  }

  static exportCSV(filename: string, text: any) {
    const createEl = document.createElement('a');
    createEl.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
    createEl.download = filename.replace(/ /g,"_") + '.csv';
    createEl.click();
    createEl.remove();
  }

  static exportPNG(filename: string, data: any) {
    const createEl = document.createElement('a');
    createEl.href = data;
    createEl.download = filename.replace(/ /g,"_") + '.png';
    createEl.click();
    createEl.remove();
  }

  static exportJPEG(filename: string, data: any) {
    const createEl = document.createElement('a');
    createEl.href = data;
    createEl.download = filename.replace(/ /g,"_") + '.jpeg';
    createEl.click();
    createEl.remove();
  }

  static exportResourceUrl(url: string) {
    const createEl = document.createElement('a');
    createEl.href = url;
    createEl.click();
    createEl.remove();
  }

  static exportImageUrlWithBoundingBox(
    url: string,
    filename: string,
    extension: string,
    boundingBox: Array<[number, number]>,
    color: string,
    callback: (result: boolean) => void
  ): void {
    const canvasEl = document.createElement('canvas');

    function resizeCanvas(originalCanvas: HTMLCanvasElement, maxWidth: number, maxHeight: number): HTMLCanvasElement {
      const tmpCanvas = document.createElement('canvas');
      const ctx = tmpCanvas.getContext('2d');

      if (ctx) {
        const ratio = Math.min(maxWidth / originalCanvas.width, maxHeight / originalCanvas.height);
        tmpCanvas.width = originalCanvas.width * ratio;
        tmpCanvas.height = originalCanvas.height * ratio;
        ctx.drawImage(originalCanvas, 0, 0, tmpCanvas.width, tmpCanvas.height);
      }

      return tmpCanvas;
    }

    function normalizeToPolygon(points: Array<[number, number]>): Array<[number, number]> {
      if (!points || points.length < 2) return [];

      if (points.length === 2) {
        const [[x1, y1], [x2, y2]] = points;

        const left = Math.min(x1, x2);
        const right = Math.max(x1, x2);
        const top = Math.min(y1, y2);
        const bottom = Math.max(y1, y2);

        return [
          [left, top],
          [right, top],
          [right, bottom],
          [left, bottom]
        ];
      }

      return points;
    }

    const image = new Image();

    image.onload = () => {
      canvasEl.width = image.naturalWidth;
      canvasEl.height = image.naturalHeight;

      const ctx = canvasEl.getContext('2d');
      if (!ctx) {
        callback(false);
        return;
      }

      ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight);

      const polygon = normalizeToPolygon(boundingBox);
      if (polygon.length >= 2) {
        ctx.beginPath();
        ctx.moveTo(polygon[0][0], polygon[0][1]);

        for (let i = 1; i < polygon.length; i++) {
          ctx.lineTo(polygon[i][0], polygon[i][1]);
        }

        ctx.closePath();
        ctx.lineWidth = 10;
        ctx.strokeStyle = color;
        ctx.stroke();
      }

      const resizedCanvas = resizeCanvas(canvasEl, image.naturalWidth / 2.0, image.naturalHeight / 2.0);

      resizedCanvas.toBlob((blob) => {
        if (blob) {
          const link = document.createElement('a');
          link.download = filename.replace(/ /g, "_");
          link.href = URL.createObjectURL(blob);
          link.click();
          callback(true);
        } else {
          callback(false);
        }
      }, 'image/' + extension.toLowerCase());
    };

    image.onerror = () => callback(false);

    fetch(url)
      .then(response => response.blob())
      .then((data: Blob) => {
        FileTools.pFileReader(data).then(event => {
          const reader = event?.target;
          image.src = typeof reader?.result === 'string' ? reader.result : '';
        }).catch(() => callback(false));
      })
      .catch(() => callback(false));
  }
}
